import { Layout } from 'antd';
import styled from 'styled-components';

export const ContentOnlyWrapper = styled(Layout)``;
